import React, {useEffect, useState} from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {HEADER} from '@optimaxdev/analytics/mobile/constants/events/header';
import {Drawer, pushSnackAlert, SnackBarsContainer, Theme} from '@optimaxdev/design-system';

import {getIsOutOfStock} from 'hooks/getQuoteItemsCart/stockAccumulation';
import {useGetQuoteItemsCartData} from 'hooks/getQuoteItemsCart/useGetQuoteItemsCart';

import {AppCrashFallback, ErrorBoundary} from '../components/appCrashFallback';

import {HostApplicationStoreType} from '../hostApplicationStoreType';

import {miniCartDrawerEvent} from './analytic/analytic';
import {useGetQuoteItemsCartDataQueryKey} from './constants';
import {MiniCartContent} from './miniCartContent/miniCartContent';
import {MiniCartHeader} from './miniCartHeader/miniCartHeader';

/**
 * Mini Cart Container
 */
const DesktopMiniCart = () => {
    const [isDrawerOpened, closeDrawer] = useState(true);
    const {data, isLoading} = useGetQuoteItemsCartData({
        queryKey: useGetQuoteItemsCartDataQueryKey,
    });

    useEffect(() => {
        if (getIsOutOfStock(data?.items))
            pushSnackAlert(null, `Some items in your cart are sold out. Remove them to proceed.`, {
                hasAutoClose: true,
                iconType: 'alert',
                variant: 'notification',
            });
    }, [data?.items]);

    useEffect(() => {
        if (data?.items?.length === 0) closeDrawer(false);
    }, [data?.items]);

    const handleCloseDrawer = () => {
        closeDrawer(false);
        miniCartDrawerEvent('Close');
    };

    useEffect(() => {
        if (isDrawerOpened) {
            sendDesktopAnalyticsPerSession({
                event: HEADER.BUTTON,
                isInteraction: true,
                label: {
                    buttonName: 'Mini Cart',
                    label: 'Show',
                },
            });
        }
    }, [isDrawerOpened]);

    return (
        <Theme theme={{isBlueTheme: true}}>
            <ErrorBoundary
                fallback={() => (
                    <AppCrashFallback
                        selector={(state: HostApplicationStoreType) =>
                            state.checkoutPage?.orderData?.orderId
                        }
                        platform="mobile"
                    />
                )}
            >
                <Drawer
                    customHeader={
                        <MiniCartHeader closeDrawer={handleCloseDrawer} isLoading={isLoading} />
                    }
                    isOpened={isDrawerOpened}
                    onClick={handleCloseDrawer}
                >
                    <MiniCartContent isLoading={isLoading} items={data?.items} />
                </Drawer>
                <SnackBarsContainer />
            </ErrorBoundary>
        </Theme>
    );
};

export default DesktopMiniCart;
